import timestamp from 'time-stamp';
import { differenceInYears, isValid, parse } from 'date-fns';
import { WEEK_DAYS } from '../constants/time.constants';

export const getTimezoneOffset = () =>
  window.TZ_OFFSET || new Date().getTimezoneOffset(); // for debugging & testing
window.getTimezoneOffset = getTimezoneOffset;

const serverUtcOffset = -3 * 60 * 60 * 1000; // utc: 18:00, server: 21:00, res: -3h
const ourUtcOffset = getTimezoneOffset() * 60 * 1000; // utc: 18:00, our: 22:00, res: -4h
const diffServerAndOur = serverUtcOffset - ourUtcOffset; // res: 1h

export const convertTimeToPricingServer = (time) => time - diffServerAndOur;
export const convertTimeToClient = (time) => time + diffServerAndOur;

export const timeStamp = () => timestamp('HH:mm:ss.ms');

export const parseBirthDate = (birthDate) =>
  parse(birthDate, 'ddMMyyyy', new Date());

export const validBirthDate = (birthDate) => isValid(parseBirthDate(birthDate));

export const getAgeByBirthDate = (birthDate) =>
  differenceInYears(new Date(), parseBirthDate(birthDate));

export const millisecondsToMinutes = (milliseconds) =>
  Math.floor(milliseconds / 1000 / 60);

export const sortOldOrdersFirst = (data) =>
  data.slice().sort((a, b) => {
    const time1 = a?.time_created;
    const time2 = b?.time_created;

    return time1 > time2 ? 1 : time1 < time2 ? -1 : 0;
  });

export const getWeekDay = () => WEEK_DAYS[new Date().getDay()];

export const sleep = (time) =>
  new Promise((resolve) => {
    setTimeout(resolve, time);
  });
